import React, { useCallback } from 'react';
import { List } from 'antd';
import UserSelectionContext from '../context';
import { filterSearchDepts } from '../common';
import TabPaneListItem from '../tabs/TabPaneListItem';
import arrowRightIcon from '../../images/app_ic_arrow_right.png';
function SearchDepartmentList(_a) {
    var searchData = _a.searchData, onclick = _a.onclick, loadMore = _a.loadMore, onOrgClick = _a.onOrgClick, result = _a.result, loading = _a.loading, onItemCheck = _a.onItemCheck;
    var _b = React.useContext(UserSelectionContext), t = _b.t, tabs = _b.tabs, frozenIds = _b.frozenIds, chooseOnlyDepart = _b.chooseOnlyDepart, canSelectDept = _b.canSelectDept;
    var DeptsInfoData = filterSearchDepts(searchData.depts, result, chooseOnlyDepart || canSelectDept, frozenIds) ||
        [];
    var getExtraPart = useCallback(function (deptItem) {
        if (chooseOnlyDepart || canSelectDept) {
            return (React.createElement("div", { className: deptItem.checked
                    ? "focus-user-selection-dept selection-dept-disabled"
                    : 'focus-user-selection-dept', onClick: function (event) {
                    event.stopPropagation();
                    if (!deptItem.checked) {
                        onOrgClick(deptItem);
                    }
                } },
                React.createElement("span", { className: "focus-user-selection-dept-arrow org-dept-arrow " },
                    React.createElement("img", { src: arrowRightIcon, alt: "" }))));
        }
        return (React.createElement("span", { className: "focus-user-selection-dept-arrow", onClick: function (event) {
                onOrgClick(deptItem);
                // onDeptClick(deptItem.deptId);
                event.stopPropagation();
            } },
            React.createElement("img", { src: arrowRightIcon, alt: "" })));
    }, [canSelectDept, chooseOnlyDepart, onOrgClick]);
    var getDisabled = useCallback(function (item) {
        return frozenIds.findIndex(function (id) { return id === item.deptId; }) >= 0;
    }, [frozenIds]);
    // if (loading) {
    //     return (
    //         <div
    //             style={{
    //                 width: '100%',
    //                 height: '100%',
    //                 display: 'flex',
    //                 flexDirection: 'column',
    //                 minHeight: '200px',
    //                 background: '#fff',
    //             }}
    //         >
    //             <Loading />
    //         </div>
    //     );
    // }
    return (React.createElement("div", { className: "search-content-wrap" },
        React.createElement(List, { loadMore: loadMore, dataSource: DeptsInfoData, renderItem: function (item, key) {
                return (React.createElement(TabPaneListItem, { data: item, onClick: function (event) {
                        if (!canSelectDept || !chooseOnlyDepart) {
                            onOrgClick(item);
                        }
                    }, disabled: getDisabled(item), key: key, checkable: chooseOnlyDepart || canSelectDept, onCheckChange: function (deptItem) {
                        onItemCheck(deptItem);
                    }, extra: getExtraPart(item) }));
            } })));
}
export default SearchDepartmentList;
//# sourceMappingURL=SearchDepartmentList.js.map